import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import { date, replaceStrDate, nodeType, nodeTypeIcon } from '@zzzj/zzzj/src/filters';
import store from '@/store';
import 'dayjs/locale/zh-cn';
var dayjs = require('dayjs');
var isSameOrBefore = require('dayjs/plugin/isSameOrBefore');
dayjs.extend(isSameOrBefore);
dayjs.locale('zh-cn');
function getBTypeName(val, type) {
  if (val) {
    var item = store.state.cpscc.bTypeList.find(function (child) {
      return child.n01Code === val;
    });
    if (item) {
      if (type === 'name') {
        return "".concat(item.n01Name);
      }
      return "(".concat(item.n01Code, ")").concat(item.n01Name);
    }
  }
  return val;
}
function toDayJs(date) {
  return dayjs(date);
}
function dateToCNByDayJs(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY年MM月DD日';
  var d = toDayJs(date);
  return d.format(format);
}
function toThousandsForMates(num) {
  if (!isNaN(parseFloat(num))) {
    return Number(Number(num).toFixed(2)).toLocaleString('zh', {
      minimumFractionDigits: 2
    });
  }
  return '';
}
export { date, dateToCNByDayJs, toDayJs, replaceStrDate, nodeType, nodeTypeIcon, getBTypeName, toThousandsForMates };